import { cx } from "@emotion/css";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { useToggleStar } from "src/hooks/useExam";
import BasicStarIcon from "src/images/Icons/newIcons/exam/options/star.svg";

import DefaultOptions from "./DefaultOption";

function Star(props) {
	const { t } = useTranslation();
	const { mutate: toggleStar } = useToggleStar();

	return (
		<DefaultOptions
			keysToPress={["Meta + u"]}
			optionKey="star"
			testId="question-star-button"
			dispatch={props.dispatch}
			Icon={
				<BasicStarIcon
					className={cx("icon-normal", {
						"icon-yellow": props.details.isStarred,
					})}
				/>
			}
			text={t("exam.star")}
			onClick={() => toggleStar(props.details.id)}
			className={props.className}
			settings={props.settings}
			disabled={!props.details.visibility?.starred}
		/>
	);
}

export default styled(Star)``;
